import TwitterIcon from 'react-scale/components/icons/Twitter';
import LinkedinIcon from 'react-scale/components/icons/Linkedin';

const Header = ({ speaker }) => (
  <div>
    <h1 className="text-5xl leading-none">{speaker.name}</h1>
    <div className="flex flex-col justify-between mt-4 space-y-2 md:hidden">
      <Title positions={speaker.positions} />
      <Socials speaker={speaker} />
    </div>
  </div>
);

export const Title = ({ positions }) => (
  <div>
    {positions.map(p => (
      <div>
        {p.text}, <CompanyName position={p} />
      </div>
    ))}
  </div>
);

const CompanyName = ({ position }) => (
  <>
    {position.companyHref ? (
      <a
        href={position.companyHref}
        target="_blank"
        className="text-transform-x-gradient"
        rel="noreferrer"
      >
        {position.companyName}
      </a>
    ) : (
      <span className="text-transform-x-gradient">{position.companyName}</span>
    )}
  </>
);

export const Socials = ({ speaker: { twitterHref, linkedinHref } }) => (
  <div className="flex items-center gap-4 md:justify-center">
    {twitterHref && (
      <a href={twitterHref} target="_blank" rel="noreferrer">
        <TwitterIcon className="w-6 fill-current" />
      </a>
    )}
    {linkedinHref && (
      <a href={linkedinHref} target="_blank" rel="noreferrer">
        <LinkedinIcon className="w-6 fill-current" />
      </a>
    )}
  </div>
);

export default Header;
